import {
  getFirstManageSite,
  getSiteDomain,
  isMultiManageSite,
  isSplitSitePage,
} from '..';
import { ADMIN_PREFIX, ADMIN_PROXY_HYBRID } from '../../api/config';
import { isSupportSystem } from '../../config';
import { AccountType, IString } from '../../model';

// 跨平台参数处理
export const formatReqParams = (params: IString<any>, reqType: AccountType) => {
  switch (reqType) {
    case AccountType.TAPD:
      return Object.assign(params, {
        limit: params.per_page,
      });
    default:
      return params;
  }
};

export const wrapRequestArea = async <R>(
  requestFun: () => Promise<R>,
  site?: string
) => {
  if (isMultiManageSite()) {
    window.requestArea = site;
  }

  const res = await requestFun();
  return res;
};

export const getReformPath = (path: string) => {
  if (!isMultiManageSite()) {
    window.requestArea = undefined;
    return path;
  }
  if (
    path.includes('ingame.OpenApiSrv/GetUserPerm') ||
    path.includes('ingame.OpenApiSrv/GetRoleList')
  ) {
    window.requestArea = undefined;
    return path;
  }
  if (
    ['admin/organization-manage', '/admin/support-permission'].some(
      (pagePath) => location.pathname.endsWith(pagePath)
    ) &&
    !path.includes('/api/app-config')
  ) {
    window.requestArea = undefined;
    return path;
  }

  if (
    path.includes('/support-user') ||
    path.includes('/tof') ||
    path.includes('/logout')
  ) {
    window.requestArea = undefined;
    return path;
  }
  const params = new URLSearchParams(location.search);
  const siteQuery = params.get('site') || '';

  const isSupportUrl = path.startsWith(ADMIN_PREFIX);
  const isSupportRequest =
    ((isSupportSystem() || location.pathname.startsWith('/admin')) &&
      isSupportUrl) ||
    path.includes('/api/app-config');

  if (!isSupportRequest) {
    window.requestArea = undefined;
    return path;
  }

  const newPath = getSupportRequestUrlByArea(path, siteQuery);
  window.requestArea = undefined;
  return newPath;
};

export const getSupportRequestUrlByArea = (url: string, siteQuery: string) => {
  const requestArea =
    window.requestArea ||
    (isSplitSitePage() && siteQuery) ||
    getFirstManageSite();

  if (!requestArea) {
    return url;
  }

  const baseUrl = `${ADMIN_PROXY_HYBRID}${url}`;
  const targetDomain = getSiteDomain(requestArea);
  if (!targetDomain) {
    throw new Error('targetDomain 不存在');
  }
  if (targetDomain.includes(location.host)) {
    return url;
  }
  if (url.includes('?')) {
    return `${baseUrl}&targetDomain=${targetDomain}`;
  }

  return `${baseUrl}?targetDomain=${targetDomain}`;
};
